<script lang="ts">
  export let title: string;
  export let thumbnailSrc: string;
  export let thumbnailAlt: string;
  export let description: string;
  export let src: string | null = null;
  export let href: string | null = null;

  $: location = href || src || 'https://utheory.com';
  $: isDownload = src && !href;
  $: isExternal = isDownload || href?.slice(0, 4) === 'http';
  $: rel = isDownload || isExternal ? 'external' : '';
  $: downloadText = isDownload ? 'Download' : 'Open';
</script>

<div class="mb-4 xs:mb-0 border shadow-lg text-center bg-blue-50 rounded-lg flex flex-col">
  <div class="p-1 bg-green rounded-t-lg overflow-hidden text-white">
    <h4 class="h4 text-white"><a {rel} href={location}>{title}</a></h4>
  </div>
  <a class="block mx-auto" {rel} href={location}>
    <img class="py-2 px-4 h-48" src={thumbnailSrc} alt={thumbnailAlt} />
  </a>
  <p class="text-gray my-1 py-1 px-1 flex-grow">{description}</p>
  <div>
    <a
      class="btn bg-orange rounded-lg shadow m-2"
      {rel}
      download={isDownload ? '' : null}
      href={location}>{downloadText}</a
    >
  </div>
</div>
